import React from 'react'
import Hero from '../components/Hero'
import Container from '../components/Container'

export default function Error404Page() {
  return (
    <Container>
      <Hero>
        <h1>Den siden finnes ikke</h1>
      </Hero>
    </Container>
  )
}
